import script from "./glow-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./glow-button.vue?vue&type=script&setup=true&lang=ts"

import "./glow-button.vue?vue&type=style&index=0&id=3bb7867e&lang=scss"

const __exports__ = script;

export default __exports__